<template>
    <section class="l-section o-header">
        <div class="l-container">
            <div class="l-row o-header__row">
                <div v-if="title" class="l-row__column o-header__titleColumn">
                    <p class="a-title o-header__title">
                        {{ title }}
                    </p>
                </div>
                <div
                    class="l-row__column o-header__mobileColumn"
                    :style="{ visibility: hideHeader ? 'hidden' : 'visible' }"
                >
                    <dashboard-top-menu
                        v-if="$route.meta.requiresAuth || token"
                    />
                    <dashboard-tabs
                        v-if="($route.meta.requiresAuth || token) && isMobile"
                    />
                    <figure class="a-image o-header__logo">
                        <img src="@/assets/logo.png" alt="Take a Fruit Logo" />
                    </figure>
                    <figure class="a-image o-header__logoUE">
                        <img src="@/assets/eu-logo.png" alt="UE Logo" />
                    </figure>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import DashboardTabs from './dashboard/DashboardTabs.vue'
import DashboardTopMenu from './dashboard/DashboardTopMenu.vue'
export default {
    components: { DashboardTopMenu, DashboardTabs },
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isMobile: false
        }
    },
    computed: {
        hideHeader() {
            return (
                window.innerWidth <= 1024 &&
                this.$route.name === 'cart-mobile-week'
            )
        },
        token() {
            return this.$store.getters['users/token']
        }
    },
    methods: {
        checkIsMobile() {
            if (window.innerWidth <= 1024) {
                this.isMobile = true
            } else {
                this.isMobile = false
            }
        }
    },
    mounted() {
        this.checkIsMobile()
    }
}
</script>
